import React, { useEffect, useState } from "react";
import API from "../services/api";
import { toast } from "react-toastify";

function WeatherCard() {
  const [weather, setWeather] = useState(null);
  const [loadingLocation, setLoadingLocation] = useState(false);

  useEffect(() => {
    fetchWeather();
  }, []);

  const fetchWeather = async () => {
    try {
      const res = await API.get("/weather/current");
      setWeather(res.data);
    } catch (err) {
      console.log("No weather data yet");
    }
  };

  const enableLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation not supported by browser");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          await API.post("/weather/save-location", {
            latitude,
            longitude,
            address: "Browser location"
          });

          toast.success("Location saved successfully");

          /*
            Optional demo weather log
            Replace later with OpenWeather API
          */
          await API.post("/weather/log", {
            temperature: 28,
            humidity: 75,
            rainfall: 0,
            wind_speed: 12,
            weather_condition: "Sunny"
          });

          fetchWeather();
        } catch (err) {
          toast.error("Failed to save location");
        }

        setLoadingLocation(false);
      },
      (error) => {
        toast.error("Location access denied");
        setLoadingLocation(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  return (
    <div className="card dashboard-card h-100">
      <h5>📍 Location & Weather</h5>

      {weather ? (
        <>
          <h3>{weather.temperature}°C</h3>
          <p>{weather.weather_condition}</p>
          <p>Humidity: {weather.humidity}%</p>
          <p>Rainfall: {weather.rainfall} mm</p>
          <p>Wind: {weather.wind_speed} km/h</p>
        </>
      ) : (
        <div>
          <p>No weather data available</p>

          <button
            className="btn btn-dark"
            onClick={enableLocation}
            disabled={loadingLocation}
          >
            {loadingLocation
              ? "Getting Location..."
              : "Enable Location"}
          </button>
        </div>
      )}
    </div>
  );
}

export default WeatherCard;